import { passThroughEffectiveFilter } from '../engine/default-handlers';
import { defineListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const founderGenderDescriptor = defineListFilter({
  definition: {
    id: FilterId.FOUNDER_GENDER,
    name: 'Founder Gender',
    selectionListId: 'gender',
    selections: [],
    type: FilterType.LIST,
    isVisible: true,
  },
  handler: { getEffectiveFilter: passThroughEffectiveFilter },
});
